<app-steps [step]='3'></app-steps>

<div class="row">
    <div class="col-sm-5">
        <div class="card">
            <div class="card-body">
                <div class="card-title">
                    Booking Summary
                </div>
                <div *ngIf="preferredDateAndTime==null || selectedService==null || order==null">
                    <p class="card-text">
                        <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading Appointment Details....
                    </p>
                </div>
                <div *ngIf="preferredDateAndTime!=null && selectedService!=null && order!=null">
                    <div class="row">
                        <div class="col">
                            <mat-form-field appearance="outline">
                                <mat-label>Treatment</mat-label>
                                <input matInput readonly value="{{selectedService.name}}" type="text">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field appearance="outline">
                                <mat-label>Practitioner</mat-label>
                                <input matInput readonly value="{{preferredDateAndTime.slots[0].staffName}}"
                                    type="text">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Appointment Date</mat-label>
                                <input matInput readonly value="{{preferredDateAndTime.time | date: 'dd-MM-yyyy'}}"
                                    type="text">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Time</mat-label>
                                <input matInput readonly value="{{preferredDateAndTime.time | date: 'hh:mm a'}}"
                                    type="text">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="app.customer!=null && !app.customer.isNewCustomer && !app.customer.is2YearLastTransaction">
                        <div class="col-sm-12">
                            <mat-form-field appearance="outline">
                                <mat-label>Price</mat-label>
                                <input matInput readonly value="${{selectedService.fee | number:'1.2'}}" type="text">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" *ngIf="app.customer!=null && (app.customer.isNewCustomer || app.customer.is2YearLastTransaction) && showPayPal">
                        <div class="col-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Price</mat-label>
                                <input matInput readonly value="${{selectedService.fee | number:'1.2'}}" type="text">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-6">
                            <mat-form-field appearance="outline">
                                <mat-label>Required Deposit</mat-label>
                                <input matInput readonly value="${{order.onlinePaymentAmountToBePaid | number:'1.2'}}" type="text">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="card-title">
                    Contact Details
                </div>
                <div *ngIf="app!=null && app.customer==null">
                    <p class="card-text">
                        <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading your information...
                    </p>
                </div>
                <div *ngIf="app!=null && app.customer!=null">
                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput readonly value="{{app.customer.firstName}}&nbsp;{{app.customer.lastName}}"
                            type="text">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput readonly value="{{app.customer.email}}" type="text">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>Phone</mat-label>
                        <input matInput readonly value="{{app.customer.mobilePhoneNumber}}" type="text">
                    </mat-form-field>
                </div>
                <div class="row">
                    <div class="col">
                        <a class="btn btn-secondary full-width" (click)="back()">Change Booking Details</a>
                    </div>
                    <!-- <div class="col">
                        <a class="btn btn-secondary full-width" (click)="cancelPendingTransaction()">Cancel Booking Transaction</a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-7">
        <div class="card bg-transparent">
            <div class="card-body">
                <div class="row">
                    <div class="col">
                        <h3 class="card-title main-title">Confirm Appointment</h3>
                    </div>
                </div>
                <hr>
                <div class="card-title">
                    <strong style="font-size: 1.5em;">Terms of use</strong>
                </div>
                <div class="card-text">
                    <p style="font-size: 1.5em;">
                        We understand that unexpected issues may arise and you may need to reschedule or cancel an
                        appointment. If that happens we respectfully ask for 24 hours notice. Our Practitioners want to
                        be available
                        for all patient’s needs. When a patient does not show up for a scheduled appointment another
                        patient
                        loses an opportunity to be seen.
                    </p>
                    <p style="font-size: 1.5em;">
                        All required deposits and payments are refundable with a minimum of 24 hours notice.
                    </p>
                    <p style="font-size: 1.5em;">
                        Failure to provide 24 hours notice for rescheduling or cancellation of an appointment and/or
                        failure to attend an appointment will incur a $50 charge. We thank you for understanding.
                    </p>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-checkbox [(ngModel)]="acceptTerms" style="font-size: 1.5em;">
                            I accept the Terms of use.
                        </mat-checkbox>
                        <br>
                    </div>
                </div>

                <div>
                    <div>
                        <hr>
                        <div class="card-text">
                            <strong>If you will be using a Gift Voucher please click below</strong>
                        </div>
                        <a class="btn btn-blue full-width" (click)="redirectToGiftVoucherRedemption()">
                            Gift Voucher No.
                        </a>
                    </div>
                    <div *ngIf="app!=null && app.customer!=null && !app.customer.isNewCustomer && !app.customer.is2YearLastTransaction">
                        <div *ngIf="!isPassSeven">
                            <hr>
                            <div class="card-text">
                                <strong>or click the Book Button to pay at time of your Appointment</strong>
                            </div>
                            <a class="btn btn-blue full-width" (click)="confirmAppointment(false)">Book</a>
                        </div>
                        <div *ngIf="showPayPal">
                            <hr>
                            <div class="card-text">
                                <strong>or click the PayPal Button to pay for your appointment now, using Paypal or a Credit Card</strong>
                            </div>
                            <a id="paypal-button-container" class="full-width"></a>
                        </div>
                    </div>
                    <div *ngIf="app.customer!=null && (app.customer.isNewCustomer || app.customer.is2YearLastTransaction) && showPayPal">
                        <hr>
                        <div class="card-text">
                            <strong>or click the PayPal Button to pay for your appointment now, using Paypal or a Credit Card</strong>
                        </div>
                        <a id="paypal-button-container" class="full-width"></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #tplGvInput>
    <div class="modal-header">
        <span class="modal-title">
            Redeem Gift Voucher
        </span>
    </div>
    <div class="modal-body">
        <div class="e-card">
            <div class="e-card-title" style="padding:15px 15px 0px 15px; text-align: justify;">
                Enter Gift Voucher Number
            </div>
            <div class="e-card-bardcode-input" style="padding:15px 15px 10px 15px;">
                <div class="input-group input-max" style="border: 1px solid #009CDE!important;">
                    <div class="input-group-append" *ngIf="app.config.digitalGlueVoucherPrefix!=''">
                        <span class="input-group-text" id="basic-addon1">{{app.config.digitalGlueVoucherPrefix}}</span>
                    </div>
                    <kendo-maskedtextbox #gvCode [(value)]="giftVoucherNumber" class="form-control">
                    </kendo-maskedtextbox>
                    <div class="input-group-append">
                        <button class="btn btn-blue mask-button" type="button" (click)="this.giftVoucherNumber = ''">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a class="btn btn-blue" (click)="hideModal(modalGvInput)">Cancel</a>
        <a class="btn btn-blue" (click)="checkGiftVoucher()">Confirm</a>
    </div>
</ng-template>

<ng-template #tplReEnterMessage>
    <div class="modal-header">
        <h4 class="modal-title pull-left">Message</h4>
    </div>
    <div class="modal-body">
        <p *ngIf="app.config!=null" [innerHTML]="app.config.invalidBarcodeMessage"></p>
    </div>
    <div class="modal-footer text-right">
        <button type="button" class="btn btn-blue" aria-label="Close" (click)="closetplReEnterMessage()">
            Re-enter Barcode
        </button>
        <a class="btn btn-blue" (click)="giftVoucherNumber='';this.modalGvReenterNumber.hide();">Cancel</a>
    </div>
</ng-template>